var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-lateral',{ref:"modalChatearAsesor",attrs:{"titulo":"Asesor de leeche"}},[_vm._v(" chat con asesor ")])
}
var staticRenderFns = []

export { render, staticRenderFns }